<template>
    <div>
        <el-table
                border
                :data="tableList"
                :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
            <el-table-column
                    fixed
                    prop="date"
                    type="index"
                    label="序号"
                    align="center"
                    width="60px">
                <template scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    fixed
                    prop="date"
                    align="center"
                    label="处理文件文号"
                    min-width="160px">
            </el-table-column>
            <el-table-column
                    prop="date"
                    align="center"
                    label="实施/认定部门"
                    min-width="160px">
            </el-table-column>
            <el-table-column
                    prop="date"
                    label="决定内容"
                    align="center"
                    width="200px">
            </el-table-column>
            <el-table-column
                    prop="date"
                    label="违规类型"
                    align="center"
                    width="205px">
<!--                <template scope="scope">-->
<!--                    <el-select placeholder="请选择" size="small" style="width: 148px">-->
<!--                        <el-option label="2020" value="2020"></el-option>-->
<!--                        <el-option label="2021" value="2021"></el-option>-->
<!--                    </el-select>-->
<!--                </template>-->
            </el-table-column>
            <el-table-column
                    prop="date"
                    align="center"
                    label="处罚时间"
                    min-width="160px">
            </el-table-column>
            <el-table-column
                    prop="date"
                    align="center"
                    label="数据来源"
                    min-width="160px">
            </el-table-column>
            <el-table-column
                    prop="dataStatus"
                    align="center"
                    label="数据状态"
                    width="160px">
                <template scope="scope">
                    <p class="data-status">
                        <i v-if="scope.row.statusNum == 1" class="effective"></i>
                        <i v-if="scope.row.statusNum == -1" class="toBeEffective"></i>
                        <i v-if="scope.row.statusNum == 0" class="toVoid"></i>
                        <span v-if="scope.row.statusNum == 1">有效</span>
                        <span v-if="scope.row.statusNum == -1">待生效</span>
                        <span v-if="scope.row.statusNum == 0">已作废</span>
                    </p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="date"
                    label="登记时间"
                    align="center"
                    width="185px">
            </el-table-column>
            <el-table-column
                    prop="date"
                    label="操作"
                    align="center"
                    width="150px">
                <template scope="scope">
                    <p class="btn-operation" v-if="scope.row.statusNum == -1"><span>修改</span><span>删除</span></p>
                    <p class="btn-operation" v-else-if="scope.row.statusNum == 1"><span>作废</span></p>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        name: "reward-information",
        data(){
            return {
                tableList:[],
                currentPage:1,
                pageSize:10,
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>